import type { FaireProductEntity } from "../../entity_types/product";

export const p_pv6jmpf6j2: FaireProductEntity = {
  token: "p_pv6jmpf6j2",
  type: "product",
  name: "Albers Short Sleeve Sweater Tee - Obsidian",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/5def0ab178d690165c1ccac06db02bf003d46f75083debcd576e7b47c774fc50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c645a171fd5d25aca3ec2977740ea03a9c3e4f9824c56b5cbda2e0d6682f7950.jpeg",
    "https://cdn.faire.com/fastly/86211ec83151a1f5029d851a97f21fac975cb8bda7b080dc0f5e6a55e464ff9b.jpeg",
    "https://cdn.faire.com/fastly/d2fa77d1dddf94b77ad86c07bd62d784be6771344461585b5f767680d9f56a62.jpeg",
    "https://cdn.faire.com/fastly/27a7afdba278f3e72edca1c7cd303735d1f55cf3df4f914c5902afe0ed3fdf22.jpeg",
    "https://cdn.faire.com/fastly/1aa75a2d97c35d0ee125a89dd8460e1ee205e06efabfa37ea6c1c30d74ca479e.jpeg",
    "https://cdn.faire.com/fastly/60894cb56e53d8db013a71b31a4875487eaeee9213909fc6abf25455842c2f4d.jpeg",
    "https://cdn.faire.com/fastly/286ce5c29fededb125ee4c7277ef6cf56c8af5ec6a8b6781132aebe3d8626433.jpeg",
    "https://cdn.faire.com/fastly/ed89c8a7e38e7540731a5a251a831f2b9a451df7ab8f42a6deb54733db1821a2.jpeg",
    "https://cdn.faire.com/fastly/49b9c53d8e97d7bf1b54942a4af8c63de9302f6cf5d830687036bbf103c79a3a.jpeg",
    "https://cdn.faire.com/fastly/843c17ad4fc7e1ac0526a1bd9be28fe6a5314abe2d95ade86d0a4fb5429efb5f.jpeg"
  ],
  priceDollars: 75.6,
  description: "A relaxed fit with a more structured feel. The Albers Tee holds its shape with a firm, flat hand, creating clean, architectural lines that feel intentional from every angle. Inspired by the Bauhaus movement and the work of Josef Albers, color is arranged with quiet precision through blocks and grids that feel balanced and considered. Designed as a companion to the Bauhaus, it carries the same visual language in a form that layers easily and moves across wardrobes with flexibility.\n\n * 100% Pima cotton \n * Relaxed, boxy fit with drop shoulder \n * Minimal drape with a flat, slightly firm feel \n * Designed for easy layering \n * Holds its shape over time, maintaining a clean silhouette \n * Artisan made in Peru under Fair Trade practices \n\n",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:27.155Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
